import { createContext, useContext, useEffect, useState } from "react";
import client from "@/lib/api";

const ContentContext = createContext({});

const FALLBACK_LOGO =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_ecosystem-labs-2/artifacts/eh1156bh_1950C3CC-6226-4B87-972F-379D46DEEC26.png";

export function ContentProvider({ children }) {
  const [content, setContent] = useState({ logo_url: FALLBACK_LOGO });

  const refresh = () =>
    client.get("/content").then(({ data }) => data && Object.keys(data).length && setContent(data)).catch(() => {});

  useEffect(() => {
    refresh();
  }, []);

  return <ContentContext.Provider value={{ content, refresh }}>{children}</ContentContext.Provider>;
}

export const useContent = () => useContext(ContentContext);
